import { Banknote, Landmark, PiggyBank, Ticket, TrendingUp, Wallet, type LucideIcon } from 'lucide-react';
import { ACCOUNT_TYPE_LABELS, ACCOUNT_TYPE_ORDER, type AccountType } from '@lira/shared';
import type { SelectOption } from '@/components/ui';

/** Ícone lucide por tipo de conta (usado no Select e nos cabeçalhos de grupo). */
export const ACCOUNT_TYPE_ICONS: Record<AccountType, LucideIcon> = {
  checking: Landmark,
  cash: Banknote,
  savings: PiggyBank,
  investment: TrendingUp,
  voucher: Ticket,
  other: Wallet,
};

/** Opções do Select de tipo de conta, na ordem de exibição do DESIGN. */
export const ACCOUNT_TYPE_OPTIONS: SelectOption<AccountType>[] = ACCOUNT_TYPE_ORDER.map((type) => ({
  value: type,
  label: ACCOUNT_TYPE_LABELS[type],
  icon: ACCOUNT_TYPE_ICONS[type],
}));
